export default {
  title: {
    en: 'Geographic Restriction Notice',
    es: 'Aviso de Restricción Geográfica',
  },
  description: {
    en: 'You are accessing from {country}. Some features may be restricted in your region.',
    es: 'Estás accediendo desde {country}. Algunas funciones pueden estar restringidas en tu región.',
  },
  dismiss: {
    en: 'Dismiss',
    es: 'Cerrar',
  },
}
